define.alias("shared/helpers/format-number-to-locale-string", "preview-grid/helpers/format-number-to-locale-string");